import React from 'react';
import { Button } from '@/components/ui/Button';
import { MessageBar } from '@/components/ui/MessageBar';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('Portal crashed:', error, info);
  }

  override render(): React.ReactNode {
    if (this.state.error) {
      return (
        <div className="p-6">
          <MessageBar intent="error" title="Something went wrong">
            {this.state.error.message}
          </MessageBar>
          <div className="mt-3">
            <Button onClick={() => window.location.reload()}>Reload</Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
